/** Matches multer limit on POST /content/materials/upload */
export const MAX_UPLOAD_FILES_PER_REQUEST = 50;
